import { RootState } from '../../store';

export const getTicketSelector = (state: RootState) => state?.ticketReducer?.ticket || null;
